import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import type { AuditTrailFilter } from '../../hooks/useAuditTrailFilter';

interface Props {
  filter: AuditTrailFilter;
}

export const AuditTrailMessageFilterControl = ({ filter }: Props) => {
  const { messageFilter, onMessageFilter } = filter;
  return (
    <ChakraV3.Input
      defaultValue={messageFilter}
      placeholder='Search by message'
      onChange={(event) => onMessageFilter(event.target.value)}
      size='md'
    />
  );
};
